$(document).on("turbolinks:load",function(){
	if($("#kiosk_active" ).length > 0)
	{	//console.log(KIOSK);
		//autologout on timeouts
	  	if(KIOSK.session_timeout != null && KIOSK.user != null)
		{	var timer;
	  		$(function() {
			  set_timeout();
			  $(document).bind('mousemove click keypress scroll', reset_timer);
			});
			function reset_timer() {
			  window.clearInterval(timer);
			  set_timeout();
			}
			function logout(){
				$.post({
				    url: KIOSK.logout_url,
				    dataType: 'html',
				    type: 'DELETE',
				    success: function(result) {
				        window.location.reload(true);
				    }
				});  
			}
			function set_timeout() {
				millisecs = 1000 * KIOSK.session_timeout;
			    timer=setInterval(logout,millisecs);   
			}
		}

		//screensaver solo se utente non in sessione
		if(KIOSK.screensaver != null && KIOSK.user == null)
		{	var s_saver;
			$(document).bind('mousemove click keypress scroll', function() {
			    clearTimeout(s_saver);
			    s_saver = setTimeout(function(){
			        $('#screensaver').fadeIn(2000);
			    }, 1000 * KIOSK.screensaver);
			    $('#screensaver').fadeOut(2000);
			});
		}
		//Prevent DEL key
		$(document).unbind('keydown').bind('keydown', function (event) {
		    var doPrevent = false;
		    if (event.keyCode === 8) {
		        var d = event.srcElement || event.target;
		        if ((d.tagName.toUpperCase() === 'INPUT' && (d.type.toUpperCase() === 'NUMBER' || d.type.toUpperCase() === 'TEXT' || d.type.toUpperCase() === 'PASSWORD' || d.type.toUpperCase() === 'FILE')) 
		             || d.tagName.toUpperCase() === 'TEXTAREA') {
		            doPrevent = d.readOnly || d.disabled;
		        }
		        else {
		            doPrevent = true;
		        }
		    }
		    if (doPrevent) {
		        event.preventDefault();
		    }
		});
		//disable keys tasti tastiera
    document.onkeydown = function (e) {
      var disable = KIOSK.disable_keys;
      if(disable != null)
      { var dkeys = disable.split(',');
        if(e.which != undefined)
        {
          if(dkeys.indexOf(e.which.toString()) != -1){
                  if(e.which == 112)
                  { 	document.onhelp = function() {return(false);}
      			window.onhelp = function() {return(false);}
                  }
                  return false;
          	}
        }
      }
		}
		//pulsante destro del mouse
  		if(KIOSK.disable_rmbutton)
	  	{	$(this).bind("contextmenu", function(e) {
                e.preventDefault();
            });
        }
	}
});
